module.exports = __webpack_public_path__ + "img/trust-process3.f575de66.png";